
import React from 'react';

export const searchColumns = [
    {
        Header: <div style={{ textAlign: 'left' }} >DMS Trans Type</div>,
        accessor: 'trans_type',
        Cell: row => <div style={{ textAlign: "left", paddingLeft: "5px" }}>{(row.value && row.value !== undefined && row.value !== null && row.value !== 'NULL' && row.value !== "0" && row.value !== 0) ? row.value : ""}</div>,
        classNameGet: 'vtypefilter1'
    },
    {
        Header: <div style={{ textAlign: 'left' }} >Description</div>,
        accessor: 'trans_type_name',
        Cell: row => <div className='ellipsisDiv' style={{ width: '350px', paddingLeft: "5px" }} title={(row.value && row.value !== undefined && row.value !== null && row.value !== 'NULL' && row.value !== "0" && row.value !== 0) ? row.value : ""}>{(row.value && row.value !== undefined && row.value !== null && row.value !== 'NULL' && row.value !== "0" && row.value !== 0) ? row.value : ""}</div>,
        classNameGet: 'vtypefilter2',

    },
]